import React, { useState, useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core';
import { Tab, Tabs, TabPanel } from '@redshelf/redshelf-ui';

import { BookmarksMenu, NoContentMessage, TableOfContents } from 'components';
import { SCREEN_SIZE_CATEGORIES } from 'constants';
import { BookValuesContext, ViewportValuesContext } from 'contexts';

const useStyles = makeStyles((theme) => ({
  root: {},
  tab: {
    margin: 0,
    paddingLeft: theme.spacing(4.5),
    paddingRight: theme.spacing(4.5),
  },
}));

const StyledTabPanel = withStyles((theme) => ({
  root: () => {
    return {
      margin: 0,
      overflowY: 'auto',
      maxHeight: 'calc(100vh - 211px)', // total height - Tabs menu height - ContentsMenu title height - footer height - topBar height
      [theme.breakpoints.down('sm')]: {
        maxHeight: 'calc(100vh - 125px)', // total height - Tabs menu height - ContentsMenu title height
      },
    };
  },
}))(TabPanel);

export const ContentsTabs = ({
  className,
  exists,
  empty,
  onClose,
  ...props
}) => {
  const [activeTabId, setActiveTabId] = useState(0);
  const handleTabOnChange = (event, newValue) => {
    setActiveTabId(newValue);
  };
  const classes = useStyles();

  const { book } = useContext(BookValuesContext);
  const topLevelMarkers = book.topLevelMarkers;

  const { viewport } = useContext(ViewportValuesContext);

  const [activeTabWidth, setActiveTabWidth] = useState();
  const refToC = useRef();
  const refBookmarks = useRef();

  useEffect(
    function setInitialTabWidth() {
      if (refToC.current && refBookmarks.current) {
        setActiveTabWidth(
          activeTabId === 0
            ? refToC.current.offsetWidth
            : refBookmarks.current.offsetWidth,
        );
      }
    },
    [activeTabId, refToC, refBookmarks],
  );

  return (
    <>
      <Tabs
        aria-label="content-menu-tabs"
        className={className}
        onChange={handleTabOnChange}
        value={activeTabId}
        selectionFollowsFocus={true}
        TabIndicatorProps={{
          style: { width: activeTabWidth ? `${activeTabWidth}px` : '' },
        }}
        variant={
          viewport.widthCategory === SCREEN_SIZE_CATEGORIES.PHONE
            ? 'fullWidth'
            : null
        }
        {...props}
      >
        <Tab
          ref={refToC}
          className={classes.tab}
          label="Table of Contents"
          wrapped
        />
        <Tab
          ref={refBookmarks}
          className={classes.tab}
          label="Bookmarks"
          wrapped
        />
      </Tabs>

      <StyledTabPanel value={activeTabId} index={0}>
        {topLevelMarkers && topLevelMarkers.length > 0 ? (
          <TableOfContents onClose={onClose} />
        ) : (
          <NoContentMessage
            title="No Table of Contents"
            content="Sorry, this book does not have a table of contents."
          />
        )}
      </StyledTabPanel>
      <StyledTabPanel className={className} value={activeTabId} index={1}>
        <BookmarksMenu onClose={onClose} />
      </StyledTabPanel>
    </>
  );
};

ContentsTabs.propTypes = {
  exists: PropTypes.bool,
  empty: PropTypes.bool,
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default ContentsTabs;
